module.exports = __webpack_public_path__ + "montserrat-okta-regular-webfont.8f2822b73b5f9c106c6f2e0db820bcbb.woff";